import React from 'react';

function NoPage() {
    return (
        <h></h>
    );
}

export default NoPage;